import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreDisclaimersRoutes = [
  {
    path: 'disclaimers',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Disclaimers')
      },
      permissions: ['READ_RORE_DISCLAIMERS']
    },
    children: [
      {
        path: '',
        name: 'roreDisclaimersList',
        component: wrapLegacyRoute('roreDisclaimersController', 'list')
      },
      {
        path: 'create',
        name: 'roreDisclaimerCreate',
        component: wrapLegacyRoute('roreDisclaimersController', 'create')
      },
      {
        path: ':disclaimerId(\\d+)',
        name: 'roreDisclaimerDetails',
        component: wrapLegacyRoute('roreDisclaimersController', 'details')
      }
    ]
  }
];

export default roreDisclaimersRoutes;
